import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { logout } from "../utils/auth";
import logo2 from "../assets/img/logo2.png";
import background from "../assets/img/background.png";

export default function ShiftBlock() {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);

    useEffect(() => {
        fetchStatus();
    }, []);

    function fetchStatus() {
        setLoading(true);
        window.axios
            .get("/shift-status")
            .then((response) => {
                const d = response.data;
                // Ako nije blokiran i ne treba potvrdu, vrati na glavnu
                if (!d.is_blocked && !d.needs_confirmation) {
                    navigate("/");
                    return;
                }
                // Ako treba potvrdu, idi na shift-confirm
                if (d.needs_confirmation) {
                    navigate("/shift-confirm");
                    return;
                }
                setData(d);
            })
            .catch(() => {
                navigate("/");
            })
            .finally(() => {
                setLoading(false);
            });
    }

    function handleLogout() {
        logout(navigate);
    }

    if (loading) {
        return (
            <div className="fixed w-full h-screen left-0 top-0 z-10 flex items-center justify-center bg-cover" style={{ backgroundImage: `url(${background})` }}>
                <div className="fixed glass w-full h-screen left-0 top-0 z-0 opacity-100"></div>
                <div className="z-10 text-white text-lg">Učitavanje...</div>
            </div>
        );
    }

    if (!data) return null;

    return (
        <div className="fixed w-full h-screen left-0 top-0 z-10 flex flex-wrap justify-center content-center p-24 bg-cover" style={{ backgroundImage: `url(${background})` }}>
            <div className="fixed glass w-full h-screen left-0 top-0 z-0 opacity-100"></div>

            <div className="w-96 rounded-sm bg-white shadow-xl overflow-hidden z-10">
                <div className="text-left w-full text-sm p-6 overflow-auto">
                    {/* Header */}
                    <div className="text-center mb-5">
                        <img src={logo2} className="w-60 m-auto" alt="Logo" />
                        <h2 className="text-xl font-semibold mt-4 mb-1 text-red-700">Pristup blokiran</h2>
                        <p className="text-gray-500 text-sm">{data.date}</p>
                    </div>

                    {/* Admin info */}
                    <div className="bg-gray-50 rounded-lg p-4 mb-4 space-y-2">
                        <div className="flex justify-between">
                            <span className="text-gray-500">Zaposlenik:</span>
                            <span className="font-semibold">{data.admin_name}</span>
                        </div>
                        <div className="flex justify-between">
                            <span className="text-gray-500">Prijava:</span>
                            <span className="font-semibold">{data.login_time || "-"}</span>
                        </div>
                    </div>

                    {/* Shift info */}
                    {data.shift && (
                        <div className="bg-cyan-50 border border-cyan-200 rounded-lg p-4 mb-4 space-y-2">
                            <div className="flex justify-between">
                                <span className="text-cyan-700">Smjena:</span>
                                <span className="font-semibold text-cyan-900">{data.shift.name}</span>
                            </div>
                            <div className="flex justify-between">
                                <span className="text-cyan-700">Radno vrijeme:</span>
                                <span className="font-semibold text-cyan-900">{data.shift.start_time} - {data.shift.end_time}</span>
                            </div>
                            {data.shift.tolerance_minutes > 0 && (
                                <div className="flex justify-between">
                                    <span className="text-cyan-700">Tolerancija:</span>
                                    <span className="font-semibold text-cyan-900">{data.shift.tolerance_minutes} min</span>
                                </div>
                            )}
                        </div>
                    )}

                    {/* Block message */}
                    <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4">
                        <p className="text-red-800 font-medium text-sm">
                            {data.block_reason === "no_shift"
                                ? "Nemate dodijeljenu smjenu za danas. Pristup blagajni nije moguć. Kontaktirajte glavnog administratora."
                                : "Trenutno ste izvan radnog vremena vaše smjene. Pristup blagajni nije moguć dok smjena ne započne."}
                        </p>
                    </div>
                </div>

                {/* Odjava */}
                <div className="p-4 w-full">
                    <button onClick={handleLogout} className="border border-gray-300 text-gray-700 text-lg px-4 py-3 rounded-sm w-full hover:bg-gray-50">
                        Odjava
                    </button>
                </div>
            </div>
        </div>
    );
}
